import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { useEffect } from "react";

function DefaultPage() {
  const navigate = usePageNavigate();
  useEffect(() => {
    const id = JSON.parse(sessionStorage.getItem("customer_id") as string);

    navigate({
      appPage: "INVOICES",
      pathParams: {
        customer_id: id as string,
      },
    });
  }, [navigate]);
  return null;
}

export { DefaultPage };
